import { Routes } from '@angular/router';
import { InverterStatsGraphComponent } from './components/inverter-stats-graph/inverter-stats-graph.component';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { AboutComponent } from './components/about/about.component';

export const routes: Routes = [
  { 
    path: 'golden-fields', 
    component: InverterStatsGraphComponent,
    title: 'Golden Fields'
  },
  {
    path: 'how-it-works',
    component: HowItWorksComponent,
    title: 'How It Works'
  },
  {
    path: 'about',
    component: AboutComponent,
    title: 'About Me'
  },
  { 
    path: '', 
    redirectTo: 'golden-fields', 
    pathMatch: 'full' 
  }
];
